<div *ngIf="network">
    <mat-divider></mat-divider>
    <mat-toolbar>
        <div class="font">
            <i class="fa fa-book icon" aria-hidden="true"></i> &nbsp; {{headerMsg}}
        </div>
    </mat-toolbar>
    <mat-divider class="divider"></mat-divider>

</div>
<div>
    <div *ngIf="spinner">
        <div class="lmask"></div>
    </div>
    <section>
        <div *ngIf="sharedData" style="font-weight: bold;">Power Supply Name:
            <span *ngIf="sharedData.inverterStatus != null" style="color:#0099cc">{{sharedData.psName}}</span>
            <span *ngIf="sharedData.inverterStatus == null">-</span>
        </div>
        <div *ngIf="sharedData" style="font-weight: bold;margin-top:5px;margin-bottom: 5px;" class="fontTelestat">
            Inverter Status:
            <span *ngIf="sharedData.inverterStatus == 'NORMAL'"
                class="labelStruccolorself">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == 'LINE FAILED'"
                class="labelStruccolorlnfd">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == 'ON: Local Test Cycle'"
                class="labelStruccolorself">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == 'ON: Remote test initiated'"
                class="labelStruccolorself">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == 'ALARM: Last Test Failed'"
                class="labelStruccolorlnfd">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == 'OFFLINE'"
                class="labelStruccolorlnfd">{{sharedData.inverterStatus}}</span>
            <span *ngIf="sharedData.inverterStatus == null">-</span>
        </div>
        <div style="font-weight: bold;">RMODE:
            <span *ngIf="RModeStatus == 'Enabled' || RModeStatus == 'Disabled' ">{{RModeStatus}}</span>
            <span *ngIf="RModeStatus != 'Enabled' && RModeStatus != 'Disabled' ">NA</span>
        </div>
        <div style="font-weight: bold;">Test Duration(Mins):
            <span *ngIf="sharedData && sharedData.testDurationInMin != null">{{sharedData.testDurationInMin}}</span>
            <span *ngIf="sharedData && sharedData.testDurationInMin == null">-</span>
        </div>
        <div style="font-weight: bold;">Last Run Date:
            <span *ngIf="lastRunDate != null">{{lastRunDate}}</span>
            <span *ngIf="lastRunDate == null">-</span>
        </div>
        <!-- <div style="font-weight: bold;">Last Run Status:
            <span *ngIf="lastRunStatus != null">{{lastRunStatus}}</span>
            <span *ngIf="lastRunStatus == null">-</span>
        </div> -->
        <!-- <div style="font-weight: bold;padding-top:5px;">Last Run Status:
            <span *ngIf="remotestatus == 'Self Test Initiated'" class="labelStruccolorself">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == 'Self Test Running'" class="labelStruccolorself">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == 'Self Test Completed'" class="labelStruccolorself">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == 'SUCCESS'" class="labelStruccolorself">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == 'FAILURE'" class="labelStruccolorlnfd">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == 'Self Test Failed'" class="labelStruccolorlnfd">{{remotestatus + " " + remotestatustimer}}</span>
            <span *ngIf="remotestatus == null">-</span>
        </div> -->
        <div style="font-weight: bold;padding-top:5px;">Last Run Status:
            <span *ngIf="lastRunStatusTelemetry == 'FAILURE'" class="labelStruccolorlnfd">{{remotestatustimer}}</span>
            <span *ngIf="lastRunStatusTelemetry == 'Start Failed - Test never started'" class="labelStruccolorlnfd">{{remotestatustimer}}</span>
            <span *ngIf="lastRunStatusTelemetry == 'Remote Test Initiated'" class="labelStruccolorself">{{remotestatustimer}}</span>
            <span *ngIf="lastRunStatusTelemetry == 'SUCCESS'" class="labelStruccolorself">{{remotestatustimer}}</span>
            <span *ngIf="lastRunStatusTelemetry == null">-</span>
        </div>
        <mat-card style="padding:0px;">
            <div id="wrapper" class="secOne">
                <div id="outer">
                    <div class="inner">
                        <button class="btncls" (click)="openDialog('Self Test Start')" *ngIf="psSelfTestStartShow"
                            [disabled]="isSelfTestStart ? 'disabled': null || ip == null ? 'disabled' : null" mat-button>
                            <mat-icon>check_circle</mat-icon>
                            <b>Start</b>
                        </button>
                    </div>
                    <div class="inner" *ngIf="sharedData">
                        <div *ngIf="sharedData.inverterStatus == 'ON: Remote test initiated'">
                            <button class="btncls" (click)="openDialog('Self Test Stop')" *ngIf="psSelfTestStopShow" mat-button>
                                <mat-icon>remove_circle</mat-icon><b>Stop</b>
                            </button>
                        </div>

                        <div *ngIf="sharedData.inverterStatus != 'ON: Remote test initiated'">
                            <button disabled class="btncls" (click)="openDialog('Self Test Stop')" *ngIf="psSelfTestStartShow" mat-button>
                                <mat-icon>remove_circle</mat-icon><b>Stop</b>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="inner">
                        <button class="btncls" mat-button (click)="moveToAlert()" *ngIf="psAlertShow">
                            <mat-icon>warning</mat-icon>
                            <b>PS Alert</b>
                        </button>
                    </div> -->
                </div>
                <div id="outer1">
                    <div class="inner1" *ngIf="rmode">
                        <button class="btncls" [disabled]="(RModeStatus != 'Enabled' && RModeStatus != 'Disabled')"
                                (click)="openDialog('RMODE OPERATION')" mat-button>
                            <mat-icon>swap_horizontal_circle</mat-icon>
                            <b>Toggle RMODE</b>
                        </button>
                    </div>
                    <!-- <div class="inner1" *ngIf="hmResetShow">
                        <button class="btncls" (click)="openDialog('HMS Reset')"
                            [disabled]="resetcmhmsreset ? 'disabled': null || ip == null ? 'disabled' : null" mat-button>
                            <mat-icon>restore_page</mat-icon>
                            <b>HMS Reset</b>
                        </button>
                    </div> -->

                <div class="inner1" *ngIf="cmKickStartFlag">
                    <button class="btncls" (click)="openDialog('CM Kick Start')"
                        [disabled]="cmKickStartBtn ? 'disabled': null || ip == null ? 'disabled' : null" mat-button>
                        <mat-icon>restore_page</mat-icon>
                        <b>CM Kick Start</b>
                    </button>
                </div>

                    <div class="inner1">
                        <button class="btncls" [disabled]="resetcmhmsreset ? 'disabled': null || ip == null ? 'disabled' : null"
                            (click)="openDialog('CM Reset')" mat-button *ngIf="cmResetShow">
                            <mat-icon>restore_page</mat-icon>
                            <b>CM Reset</b>
                        </button>
                    </div>
                    <!-- <div class="inner1">
                        <button class="btncls"
                            (click)="refreshOperation()" *ngIf="refreshShow" mat-button>
                            <mat-icon>refresh</mat-icon>
                            <b>Refresh</b>
                        </button>
                    </div> -->
                    <div class="inner1" *ngIf="testDurationShow">
                        <button class="btncls" (click)="editTestDuration()" mat-button>
                            <mat-icon>mode_edit</mat-icon>
                            <b>Edit Test Duration</b>
                        </button>

                    </div>

                </div>




                <mat-error *ngIf="isSelfTestStartMsg && user != ''" class="d-flex justify-content-center">
                    <strong class="color:red">Self Test already started by {{user}} at {{time}}</strong>
                </mat-error>

            </div>
        </mat-card>
        <h1 mat-dialog-title class="text-center colorFill" style="margin:0px;">Transponder Operations History</h1>
        <mat-form-field class="px-16" style="width: 50%">
            <input matInput [(ngModel)]="searchText" placeholder="Search..." autocomplete="off" style="width: 100%">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <div *ngIf="!(rowData?.length > 0)" class="noResult">No Rows to Show</div>
        <div class="wrapper">
            <div *ngFor="let searchdata of rowData | filter: searchText; let i = index">
                <p mat-list-item><b>IP: </b>{{searchdata.ipAddress}}</p>
                <p mat-list-item><b>MAC Address: </b>{{searchdata.macAddress}}</p>
                <p mat-list-item><b>Operation: </b>{{searchdata.operationPerformed}}</p>
                <p mat-list-item><b>User Name: </b>{{searchdata.userName}}</p>
                <p mat-list-item><b>Status: </b>{{searchdata.status}}</p>
                <p mat-list-item><b>Test Start Date: </b>{{searchdata.testStartDate}}</p>
                <p mat-list-item><b>Test End Date: </b>{{searchdata.actualEndDate!=null ? searchdata.actualEndDate : '-'}}</p>
                <p mat-list-item><b>Test Duration: </b>{{searchdata.testDuration}}</p>
                <p mat-list-item><b>Result: </b>{{searchdata.result}}</p>
                <div class="block_line" color="accent"></div>
            </div>
        </div>

    </section>
</div>
